<template>
  <div>
    <span class="back-btn" @click="showModal = true" v-if="isMobile" style="margin: 1rem;">&#60; Kembali</span>
    <iframe title="survey-google-form" style="margin-top: 1rem;" :src="poll_data.url_link" :width="isMobile ? screenWidth : screenWidth - 200" :height="isMobile ? screenHeight : '500'" frameborder="0">Loading…</iframe>

    <div v-if="!isMobile" class="flex justify-content-center mt-1" style="gap: 4rem;">
      <div class="flex flex-col">
        <small class="text-blue">*tekan tombol <strong>selesai</strong> jika anda sudah mengisi survei</small>
        <small class="text-red">*tekan tombol <strong>batal</strong> jika anda tidak ingin mengisi survei</small>
      </div>
      <div class="flex">
          <button @click="$router.push('/')" class="button-danger pointer">Batal</button>
          <button @click="submitPolls()" class="button-primary ml-1 pointer">Selesai</button>
      </div>
    </div>
  </div>
  <div v-if="showModal" class="card-container overlay-wrap modal active">
    <Card>
      <span class="text-bold">Apakah Anda Sudah menyelesaikan Polling ?</span>
      <div class="flex flex-col justify-content-center mt-1">
        <button class="yes-btn blue" @click="submitPolls()"> Ya, sudah </button>
        <button @click="$router.push('/')" class="no-btn"> Batal </button>
      </div>
    </Card>
  </div>
</template>

<script>
import axios from 'axios'
import Card from '@/components/CardBlank'

export default {
  components: {
    Card
  },
  name: 'PoolingMobileComponents',
  data () {
    return {
      poll_data: {},
      showModal: false
    }
  },
  methods: {
    async getPolls (id) {
      const res = await axios.get('/content/polling/' + id)
      this.poll_data = res.data
    },
    async submitPolls () {
      const id = this.poll_data.polling_id
      await axios.post('content/polling/user/' + id)
      this.poll_data = {}
      this.$router.push('/')
    }
  },
  computed: {
    formId () {
      let id = ''
      if (Object.keys(this.poll_data).length === 0) {
        id = ''
      } else {
        id = this.poll_data.url_link.split('/')[6]
      }
      return id
    },
    screenWidth () {
      return window.innerWidth - 20
    },
    isMobile () {
      return window.innerWidth < 700
    },
    screenHeight () {
      return window.screen.availHeight
    },
    pollUrl () {
      return this.$store.getter.getPollUrl
    }
  },
  mounted () {
    this.getPolls(this.$route.params.id)
  }
}
</script>
<style lang="scss" scoped>
.back-btn {
  text-decoration: underline;
  color: $blue;
  font-weight: 600;
}
.yes-btn {
  padding: .4rem .6rem;
  background-color: $blue;
  color: $white;
  outline: none;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  letter-spacing: .8px;
  min-width: 100px;
  place-self: center;
}
.no-btn {
  margin-top: 10px;
  padding: .4rem .6rem;
  background-color: $red;
  color: $black;
  outline: none;
  border: none;
  color: $white;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  min-width: 100px;
  letter-spacing: .8px;
  place-self: center;
}
</style>
